import { UploadOutlined } from '@ant-design/icons';
import {Button, Upload, Form, message} from 'antd';
import React, { useState } from 'react';
import {getStoredItem, site_url, deleteUserFile, get_uploaded_image_url} from "./client";
const CustomFileUpload = (props) => {
    const [fileList, setFileList] = useState([]);
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };
    const uploadProps = {
        action: site_url('doc/'),
        accept: ['image/jpeg', 'image/png', 'application/pdf'],
        data: {
            'uid':getStoredItem('uid'),
            'token':getStoredItem('token'),
            'form_id':props.elem.id,
        },
        maxCount: 15,
        listType: 'picture',
        beforeUpload(file){
            if(file.size > 5242880){
                const msg = "File size must be less than 5MB.";
                message.error(msg);
                return Upload.LIST_IGNORE;
            }
            setFileList([...fileList, file]);
        },
        onRemove(file) {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
            deleteUserFile({
                'uid':getStoredItem('uid'),
                'token':getStoredItem('token'),
                'eid':props.elem.id,
                'file':file
            });
        },
        onChange(info){
            let newFileList = [...info.fileList];
            newFileList = newFileList.map((file) => {
              if (file.response) {
                file.url = get_uploaded_image_url(file.name, props.elem.id);
              }
              return file;
            });
            setFileList(newFileList);
        }
    };
    const requiredRule = props.elem.required===true?[{ required: props.elem.required, message: 'Upload at least one document!'}]:[];
    return <Form.Item
        name={'elm_'+props.elem.id}
        valuePropName="fileList"
        extra={props.elem.uploadLabel}
        rules={requiredRule}
        getValueFromEvent={normFile}>
        <Upload name={props.elem.id} {...uploadProps} >
                <Button icon={<UploadOutlined />}>{props.elem.label}</Button>
        </Upload>
    </Form.Item>
    ;
};
export default CustomFileUpload;